import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const CREATE_FAVORITE_MUTATION = gql`
  mutation createFavorite(
    $title: String!
    $productId: String!
    $source: FavoriteSourceInput!
  ) {
    createFavorite(title: $title, productId: $productId, source: $source)  {
      documentId
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateFavoriteMutation extends Mutation<RootMutation> {
  document = CREATE_FAVORITE_MUTATION;
}
